import React from 'react'
import MuiTable from '../../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CAMIONES_EN_PLAYA } from '../../../../../../config/tables'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../../../config/settings'

export default function TablaCamionesEnPlayaView () {
  return (
    <div>
      <MuiTable id={TABLA_CAMIONES_EN_PLAYA} />
      <ToastContainer autoClose={INTERVALO_CORTO} />
    </div>
  )
}
